import { Box, Chip, FormControl, FormLabel, Grid, Paper, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { PFXSubItemData, PFXSubItemChosenOption, PFXSubItemOption } from "../../../../models/Interfaces";
import { selectCleverlynk } from "../../../../redux/slices/cleverlynkSlice";
import MultipleOptionButton from "./MultipleOptionButton";

import { useTranslation } from "react-i18next";
import "../../../../i18n/config";
import MultipleOptionTextInput from "./MulitpleOptionTextInput";

interface IMultipleOption {
  sub: PFXSubItemData;
  chosen: PFXSubItemChosenOption[];
  setChosen: Function;
  textFontFamily: string;
  skuMap: Map<string, number>;
}

const MultipleOption = ({ sub, chosen, setChosen, textFontFamily, skuMap }: IMultipleOption) => {
  const cleverlynk = useSelector(selectCleverlynk);
  const [remainingChoices, setRemainingChoices] = useState<number>(sub.choiceLimit!);

  const { t } = useTranslation("common");

  const modifyChosen = (option: PFXSubItemOption, quantity, controlsInventory) => {
    let new_chosen = chosen.filter(op => op.id !== option.id);
    if (quantity > 0) {
      //@ts-ignore
      delete option.tableData;
      new_chosen.push({ ...option, subitemId: sub.id!, quantity, controlsInventory, sku: option.sku ?? "" });
    }
    setChosen(new_chosen, sub.id);
  };

  const checkInventory = (option: PFXSubItemOption, q: number) => {
    if (sub.controlsInventory && option.sku !== "" && skuMap.get(option.sku!)! <= q) {
      return true;
    } else return false;
  };

  return (
    <Grid item xs={12} key={`multiple-${sub.id}`} style={{ margin: "5px 0px" }} className="subitem-render-div">
      <Paper>
        <Box p={2} pr={0}>
          <FormControl error={remainingChoices < 0} component="fieldset" style={{ width: "100%" }}>
            <FormLabel component="legend" style={{ width: "100%" }}>
              <Grid container justifyContent="flex-start">
                <Grid item container xs={12} justifyContent="flex-start">
                  <Grid item xs={12}>
                    <Typography variant="body1" style={{ fontFamily: textFontFamily, textAlign: "left" }}>
                      {sub.name}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      variant="overline"
                      style={{
                        fontFamily: textFontFamily,
                        marginRight: sub.mandatory && sub.choiceLimit! < 1000 ? 10 : "",
                      }}>
                      {sub.mandatory &&
                        sub.choiceLimit! < 1000 &&
                        `${t("choose")} ${sub.choiceLimit! > 1 ? t("upto") : ""}${sub.choiceLimit}`}
                    </Typography>
                    {sub.mandatory && (
                      <Chip
                        variant="outlined"
                        color="secondary"
                        size="small"
                        label={
                          <Typography variant="overline" style={{ fontFamily: "Inter", fontSize: "0.65rem" }}>
                            {t("mandatory")}
                          </Typography>
                        }
                        style={{ height: 20 }}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </FormLabel>
            {sub.options?.map(option =>
              !option.hidden ? (
                cleverlynk?.id === "oVmwtv9lY7" && (sub?.choiceLimit ?? 0) > 20 ? (
                  <MultipleOptionTextInput
                    key={option.id}
                    disableAddition={q => remainingChoices <= 0 || checkInventory(option, q)}
                    outOfStock={(q: number) => checkInventory(option, q)}
                    disableSubstraction={remainingChoices === sub.choiceLimit}
                    name={option.label!}
                    value={option.value}
                    modifyRemainingChoices={(e, quantity) => {
                      modifyChosen(option, quantity, sub.controlsInventory || false);
                      setRemainingChoices(r => r + e);
                    }}
                    textFontFamily={textFontFamily}
                  />
                ) : (
                  <MultipleOptionButton
                    key={option.id}
                    disableAddition={q => remainingChoices <= 0 || checkInventory(option, q)}
                    outOfStock={(q: number) => checkInventory(option, q)}
                    disableSubstraction={remainingChoices === sub.choiceLimit}
                    name={option.label!}
                    value={option.value}
                    modifyRemainingChoices={(e, quantity) => {
                      modifyChosen(option, quantity, sub.controlsInventory || false);
                      setRemainingChoices(r => r + e);
                    }}
                    textFontFamily={textFontFamily}
                  />
                )
              ) : null
            )}
          </FormControl>
        </Box>
      </Paper>
    </Grid>
  );
};

export default MultipleOption;
